<template>
  <div class="fixed-top">
    <router-link to="/order/cart" class="btn btn-success" id="ordernow">
      Thanh toán
    </router-link>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
#ordernow {
  position: absolute;
  right: 1rem;
  top: 8rem;
}
</style>
